export default function globalErrorHandler(err, withErrorNum=false) {
  let message;
  let errorNumber = 0;
  if (err.response && err.response.data && err.response.data.msg){
    message = err.response.data.msg;
    errorNumber = err.response.data.error_number;
  } else if(err.message) {
    message = err.message;
  } else {
    message = 'لدينا خطاء فني';
  }
  if(withErrorNum)
    return [message, errorNumber];
  return message;
}